import { useSearchParams } from 'react-router-dom';
import { useDrawerStore } from '../../store';
import { useBaseStore, useDeleteData, useFetchData } from '../../hooks';
import React, { useEffect, useState } from 'react';
import { BaseModel, PageableResponse } from '../../types';
import { Resource } from '../../lib/enums';
import { Spin } from 'antd';
import BaseTable from '../BaseTable';
import InfoModal from '../ui/modal/InfoModal';
import { convertDate, dateTimeFormat } from '../../lib/utils';

interface DisplayTableProps {
  api: string;
  moduleName: string;
  canEdit: boolean | undefined;
  canDelete: boolean | undefined;
  userRole: string | undefined;
}
const DisplayTable: React.FC<DisplayTableProps> = ({
  api,
  moduleName,
  canEdit,
  canDelete,
  userRole,
}) => {
  const [searchParams] = useSearchParams();
  const drawerStore = useDrawerStore();
  const baseStore = useBaseStore();

  const [spinning, setSpinning] = useState<boolean>(false);
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);

  const { data, isLoading } = useFetchData<PageableResponse<BaseModel>>(api, {
    resource: searchParams.get('resource') || Resource.MIN,
    search: searchParams.get('search') || '',
    length: parseInt(searchParams.get('length') || '999999'),
  });

  const {
    mutate,
    isSuccess: isSuccessDelete,
    isPending: isPendingDelete,
  } = useDeleteData(api);

  useEffect(() => {
    if (isSuccessDelete) {
      setSpinning(false);
      setInfoModalOpen(true);
    }
  }, [isSuccessDelete]);
  const handleDataDelete = (data: BaseModel) => {
    mutate({ id: data.id });
    setSpinning(true);
  };

  const handleDataEdit = (data: BaseModel) => {
    baseStore.setData(data);
    drawerStore.onClose();
  };

  const handleInfoModalClose = () => {
    setInfoModalOpen(false);
  };

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
    },
    {
      title: 'Description',
      dataIndex: 'description',
    },
    {
      title: 'Created By/Date',
      dataIndex: 'createdBy',
      render: (_text: string, record: any) => {
        return (
          <div className="flex flex-col">
            <span className="mr-2">{record.createdBy}</span>
            {record.timeCreated != null && (
              <span>{convertDate(record.timeCreated, dateTimeFormat)}</span>
            )}
          </div>
        );
      },
    },
    {
      title: 'Update By/Date',
      dataIndex: 'updatedBy',
      render: (_text: string, record: any) => {
        return (
          <div className="flex flex-col">
            <span className="mr-2">{record.updatedBy}</span>
            {record.timeUpdated != null && (
              <span>{convertDate(record.timeUpdated, dateTimeFormat)}</span>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <BaseTable
        dataSource={data?.data || []}
        isLoading={isLoading || isPendingDelete}
        handleDeleteButtonClick={handleDataDelete}
        handleEditButtonClick={handleDataEdit}
        module={moduleName}
        columns={columns}
        canDelete={canDelete}
        canEdit={canEdit}
        userRole={userRole}
      />
      <InfoModal
        visible={isInfoModalOpen}
        message={`${moduleName} successfully deleted`}
        onClose={handleInfoModalClose}
      />
    </>
  );
};

export default DisplayTable;
